import { render, staticRenderFns } from "./AdminOrderCustomField.vue?vue&type=template&id=4bb0a42e&scoped=true&"
import script from "./AdminOrderCustomField.vue?vue&type=script&lang=js&"
export * from "./AdminOrderCustomField.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderCustomField.vue?vue&type=style&index=0&id=4bb0a42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb0a42e",
  null
  
)

export default component.exports